import { createSlice } from '@reduxjs/toolkit';
import { AppNotification } from 'types/notification';

// initial state
const initialState = {
  unread: [] as AppNotification[]
};

// ==============================|| SLICE - MENU ||============================== //

const notifications = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    setUnreadNotifications(state, action) {
      state.unread = action.payload;
    }
  }
});

export default notifications.reducer;

export const { setUnreadNotifications } = notifications.actions;
